const styles = new Proxy({"VideoCarousel":"VideoCarousel-c3a7a","Heading":"Heading-c3a7a","Title":"Title-c3a7a","Subtitle":"Subtitle-c3a7a","CarouselWrap":"CarouselWrap-c3a7a","SlideOuter":"SlideOuter-c3a7a","Card":"Card-c3a7a","VideoWrapper":"VideoWrapper-c3a7a","Unsupported":"Unsupported-c3a7a","CardBody":"CardBody-c3a7a","CardTitle":"CardTitle-c3a7a","CardExcerpt":"CardExcerpt-c3a7a","SliderWrap":"SliderWrap-c3a7a","Dots":"Dots-c3a7a","Dot":"Dot-c3a7a","DotActive":"DotActive-c3a7a","ArrowBtn":"ArrowBtn-c3a7a","ArrowPrev":"ArrowPrev-c3a7a","ArrowNext":"ArrowNext-c3a7a","CTA":"CTA-c3a7a"}, { get: (m, k) => (typeof k === "string" ? (m[k] ?? k) : m[k]) });

// Mirrors the video URL handling in TextImageCard / VideoAccordion:
// Vimeo and YouTube links become embeds, direct .mp4/.webm links use <video>.
export default function VideoEmbed({
  videoUrl,
  videoTitle,
}: {
  videoUrl: string;
  videoTitle?: string;
}) {
  let url: URL;
  try {
    url = new URL(videoUrl);
  } catch {
    return null;
  }

  const isVimeo = url.hostname.includes("vimeo.com");
  const isYouTube =
    url.hostname.includes("youtube.com") || url.hostname.includes("youtu.be");
  const isVideo =
    url.pathname.endsWith(".mp4") || url.pathname.endsWith(".webm");

  return (
    <div className={styles.VideoWrapper}>
      {isVideo ? (
        <video controls preload="metadata">
          <source
            src={videoUrl}
            type={`video/${url.pathname.split(".").pop()}`}
          />
          Your browser does not support the video tag.
        </video>
      ) : isVimeo ? (
        <iframe
          src={`https://player.vimeo.com/video/${videoUrl.match(/vimeo\.com\/(?:video\/)?([^?/&]+)/)?.[1]}`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
          title={videoTitle ?? ""}
          tabIndex={-1}
        />
      ) : isYouTube ? (
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${videoUrl.match(/(?:(?:m\.)?youtube(?:-nocookie)?\.com\/(?:embed\/|watch\?(?:.*&)?v=)|youtu\.be\/)([^?/&]+)/)?.[1]}?modestbranding=1&rel=0`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
          title={videoTitle ?? ""}
          tabIndex={-1}
        />
      ) : (
        <p className={styles.Unsupported}>Unsupported media type</p>
      )}
    </div>
  );
}
